import { useAccountStore, useUserStore } from "base/stores";

import { MYDRIVE, SHAREDWITHME, SHAREDDRIVE } from "./picker.constants";

function divmod(x, y) {
  let div = Math.trunc(x / y);
  let rem = x % y;
  return [div, rem];
}

function s4() {
  return intToBase64(Math.floor((1 + Math.random()) * 0x10000));
}

function intToBase64(num) {
  // """Converts a positive integer into a base36 string."""
  let digits =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";
  let res = "";
  let i;
  while (!res || num > 0) {
    let result = divmod(num, 64);
    num = result[0];
    i = result[1];
    res = digits[i] + res;
  }
  return res;
}

export function generateShortId(name = "ShortId") {
  return `${name}-${s4() + intToBase64(new Date().getTime())}`;
}

export function getPrefix(prefix) {
  let start = prefix.startsWith("/") ? 1 : 0;
  let end = prefix.endsWith("/") ? prefix.length - 1 : prefix.length;
  return prefix.slice(start, end);
}

export function generateFileKey(name, prefix) {
  return `${prefix}/${generateShortId("Attach")}/${name}`;
}

export function getIndex(array, key, value) {
  let index;
  for (let i = 0; i < array.length; i++) {
    if (array[i][key] === value) {
      index = i;
      break;
    }
  }
  return index;
}

export function getFileExtension(name) {
  if (name.lastIndexOf(".") === -1) {
    return "unknown";
  } else {
    let extension = name.split(".").pop();
    return extension.toLowerCase();
  }
}

export function showMessage(message, color) {
  let x = document.getElementById("snackbar");
  x.className = "show";
  x.innerHTML = message || "";
  if (color) {
    x.style["background-color"] = color;
  }
  setTimeout(function replaceClassname() {
    x.className = x.className.replace("show", "");
  }, 3000);
}

export function getImageSrcUrl(driveId, file) {
  // let appStore = StoreProvider.getStore("App");
  // let accountDetails = appStore.get("accountDetails");
  const accountId = useAccountStore.getState()._id;
  return `/upload/2/${accountId}/${driveId.toLowerCase()}/image/${file.id}/${
    file.name
  }`;
}

export async function getSignInUrl(driveId) {
  let user = useUserStore.getState().currentUser;
  const accountId = useAccountStore.getState()._id;
  return `/upload/2/${accountId}/${driveId}/login?state=${user._id}`;
}

export function getSignOutUrl(driveId) {
  const accountId = useAccountStore.getState()._id;
  return `/upload/2/${accountId}/${driveId}/login`;
}

export function getFileSize(file) {
  const bytes = file.size;
  if (bytes === 0) {
    return "0.00 B";
  }
  var e = Math.floor(Math.log(bytes) / Math.log(1024));
  return (
    (bytes / Math.pow(1024, e)).toFixed(2) + " " + " KMGTP".charAt(e) + "B"
  );
}

export function fileSelectedOrNot(files, selectedFile) {
  if (files && selectedFile && Array.isArray(files)) {
    return files.some((value) => value.id === selectedFile.id);
  } else {
    return false;
  }
}

export function isValidToUpload(validExtensions = [], file) {
  let currentExt = file.fileExtension;
  if (!validExtensions || !currentExt) {
    return false;
  }
  //if file is folder || * found in validExtensions return true
  if (file.isFolder || validExtensions.includes("*")) {
    return true;
  }
  return validExtensions.includes(currentExt.toUpperCase());
}

export const driveEndPoints = {
  gdrive: {
    baseUrl: `https://www.googleapis.com/drive/v3/`,
    constant:
      `?orderBy=folder,name_natural&pageSize=1000&` +
      `fields=files(contentHints,description,fileExtension,fullFileExtension,hasThumbnail,iconLink,id,` +
      `imageMediaMetadata,kind,mimeType,name,originalFilename,parents,size,thumbnailLink,thumbnailVersion,` +
      `webContentLink),incompleteSearch,kind,nextPageToken`,
    generateUrl: function gerateUrl(option, type) {
      //default q for getting myDrive
      let q = `'${option.parent}' in parents`;
      //context for where to get files/drive info
      let context = "files";
      //if sharedWithMe change the q
      if (option.name === SHAREDDRIVE && option.getFilesById) {
        return `${this.baseUrl}${context}${this.constant}&includeTeamDriveItems=true&supportsTeamDrives=true&q=${q}`;
      }

      if (option.name === SHAREDWITHME && !option.getFilesById) {
        q = "sharedWithMe";
      }
      if (option.name === SHAREDDRIVE) {
        return `${this.baseUrl}drives?fields=*`;
      }
      return `${this.baseUrl}${context}${this.constant}&q=${q}`;
    }
  },
  dropbox: {
    baseUrl: `https://api.dropboxapi.com/2/`,
    generateUrl: function gerateUrls(option) {
      //default path for getting myDrive docs
      let path = "files/list_folder";
      if (option.name === SHAREDWITHME) {
        path = "sharing/list_received_files";
      } else if (option.name === MYDRIVE && option.hasMore) {
        return `${this.baseUrl}${path}/continue`;
      }
      return `${this.baseUrl}${path}`;
    }
  },
  onedrive: {
    baseUrl: `https://graph.microsoft.com/v1.0/me/`,
    generateUrl: function gerateUrls(option) {
      if (option.name === MYDRIVE) {
        return `${this.baseUrl}drive/items/${option.parent}/children?
        select=id,name,size,folder,file,image&expand=thumbnails`;
      } else if (option.name === SHAREDWITHME && option.remoteId) {
        return `${this.baseUrl}drives/${option.driveId}/items/${option.remoteId}/children`;
      } else if (option.name === SHAREDWITHME) {
        return `${this.baseUrl}drive/sharedWithMe`;
      }
    }
  }
};

export function generateAcceptTypes(extensions = []) {
  try {
    //if json -> parse and generate the accept type
    //handling it only for Attachment field validation
    if (_IsJson(extensions)) {
      return JSON.parse(extensions)
        .map((data) => `.${data}`)
        .join()
        .toLowerCase();
    }
    //if !array || is array || includes *, eligible to upload any file
    if (
      !Array.isArray(extensions) ||
      (Array.isArray(extensions) && extensions.includes("*"))
    ) {
      return "";
    }
    return extensions
      .map((data) => `.${data}`)
      .join()
      .toLowerCase();
  } catch (error) {
    return "";
  }
}

function _IsJson(str) {
  try {
    var json = JSON.parse(str);
    return typeof json === "object";
  } catch (e) {
    return false;
  }
}

export function getPublicUploadBaseUrl(flowType, flowId) {
  // let appStore = StoreProvider.getStore("App");
  // let accountDetails = appStore.get("accountDetails");
  // return `/${flowType}/2/${accountId}/publicform/${flowId}/attachment`;
}
export function getPublicDownloadBaseUrl(flowType, flowId) {
  // let appStore = StoreProvider.getStore("App");
  // let accountDetails = appStore.get("accountDetails");
  // return `/${flowType}/2/${accountId}/publicform/${flowId}/attachment`;
}

export const bytesToSize = (bytes, decimals = 0) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const isRequired = (param) => {
  throw new Error(`${param} is required.`);
};

export const base64toBlob = (base64Data, contentType) => {
  contentType = contentType || "";
  var sliceSize = 1024;
  var byteCharacters = atob(base64Data);
  var bytesLength = byteCharacters.length;
  var slicesCount = Math.ceil(bytesLength / sliceSize);
  var byteArrays = new Array(slicesCount);

  for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    var begin = sliceIndex * sliceSize;
    var end = Math.min(begin + sliceSize, bytesLength);

    var bytes = new Array(end - begin);
    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
};

export const computeFileDurationLength = (file) => {
  return new Promise((resolve) => {
    var objectURL = URL.createObjectURL(file);
    var mySound = new Audio([objectURL]);
    mySound.addEventListener(
      "canplaythrough",
      () => {
        URL.revokeObjectURL(objectURL);
        resolve({
          duration: mySound.duration
        });
      },
      false
    );
  });
};
